<template>
  <div>
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <el-form-item label="考试名称" prop="batchName" :rules="[$validate.string(30)]">
            <el-input v-model="form.batchName" :maxlength="30" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'enroll-manage-editName',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = JSON.parse(JSON.stringify(this.row))
        this.form.batchId = info
        // console.log(this.form, '23333333');
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let info
        if (this.form.batchId) {
          info = await this.$HTTP.ApiMusicbasis.copy(this.form)
        }
        // this.$message({ type: 'success', message: '操作成功' })
        this.$emit('close', true)
      }
    }
  }
}
</script>
